// extracted by mini-css-extract-plugin
export default {"group":"NavBar_group__AXGTI","navBar":"NavBar_navBar__RhgyV","abierto":"NavBar_abierto__XxkxS"};